import React from 'react';
import Link from '@material-ui/core/Link';

class Credit extends React.Component {
  render() {

    const movie = this.props.movie;
    const source = movie.source;
    const url = movie.source_link;
    
    return(
      <div>
        Original by <Link href={url} target="_blank">{source}</Link>
      </div>
    );
  }
}

export default Credit;